const rowStyles = (props) => [
  props,
  {
    style: {
      display: "grid",
      gridTemplateColumns: "var(--tableGridTemplateColumns)",
      minWidth: "var(--tableTotalColumnsWidth)",
    },
  },
];

const rowContainerStyles = (props, { instance }) =>
  [
    props,
    {
      style: {
        "--tableGridTemplateColumns": instance.visibleColumns.map((x, i) => (i === (instance.visibleColumns.length - 1)) ? `minmax(${x.width}px,1fr)` : `${x.width}px`)
          .join(" "),
        "--tableTotalColumnsWidth": `${instance.totalColumnsWidth}px`,
      },
    },
  ];

export const useGridLayout = hooks => {
  hooks.getRowProps.push(rowStyles);
  hooks.getHeaderGroupProps.push(rowStyles);
  hooks.getFooterGroupProps.push(rowStyles);
  hooks.getTableProps.push(rowContainerStyles);
};

useGridLayout.pluginName = "useGridLayout";
